var _path, _path2;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgArrowCircleBeige(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: "146px",
    height: "146px",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    fill: "rgb(223, 170, 86)",
    d: "M102.356,72.000 L103.092,72.737 L77.737,98.091 L74.908,95.264 L96.172,73.1000 L40.000,73.1000 L40.000,70.000 L96.172,70.000 L74.908,48.736 L77.737,45.909 L103.092,71.264 L102.356,72.000 Z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    stroke: "rgb(223, 170, 86)",
    strokeWidth: "4px",
    strokeLinecap: "butt",
    strokeLinejoin: "miter",
    fill: "none",
    d: "M72.000,2.001 C110.660,2.001 141.1000,33.340 141.1000,71.1000 C141.1000,110.659 110.660,141.999 72.000,141.999 C33.340,141.999 2.000,110.659 2.000,71.1000 C2.000,33.340 33.340,2.001 72.000,2.001 Z"
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgArrowCircleBeige);
export default __webpack_public_path__ + "static/media/arrow-circle-beige.b7749a1beafd1aea0a16a7abba3f6a4a.svg";
export { ForwardRef as ReactComponent };